import { api } from "./api";

export const productsService = {
  list: (params = {}) =>
    api.get("/products", { params }).then((r) => r.data),

  get: (id) => api.get(`/products/${id}`).then((r) => r.data),

  facets: () => api.get("/products/facets").then((r) => r.data),
};
